import { RegistrationFormContainer } from "../../features/auth/components/RegistrationForm";

const Registration = () => {
  return <RegistrationFormContainer />;
};

export default Registration;
